/**
 * ESCAPE KEY CLOSE
 *
 * Global handler for closing modals, nav when open
 * using the ESC key on a users keyboard
 */

VP = window.VP || {};

(function( $ ) {
	VP.escClose = {
		init: function () {
			var _this = this;

			_this.detectOpenItem();
		},

		detectOpenItem: function() {
			$( document ).keyup( function( e ) {
				if (e.which === 27 ) {
					// Nav
					if ( VP.nav.isOpen ) {
						VP.nav.closeSubMenu();
					} else if ( VP.search.isOpen ) {
						VP.search.close();
					}
				}
			});
		}
	};
})(jQuery);
